(module =>{
    "use strict";
    module.component('resumeFixedBox', {
        template: require('./resumeFixedBoxComponent.html'),
        bindings: {
            valToDisplay: "<",
            baseTitle: "<",
            correctTitle: "<",
            allSummary: "<"
        },
        controller: [ function(this: $TSFixMe) {
            const $ctrl = this;

            $ctrl.$onInit = () => {

                if(angular.isUndefinedOrNull($ctrl.allSummary)){
                    $ctrl.allSummary = true;
                }
            }
        }]
    })

})(angular.module('topline.modules'));
